export const copyProductDemo = {
  title: <>See Develocity in&nbsp;action</>,
  subtitle:
    'Get the high-level business case for investing in Develocity. Our demo video walks you through the major solution capabilities, describes their key benefits, and demos real-world practical examples of powerful features that address your top developer productivity pain points.',
  button: 'Watch the product demo',
  videoLink: 'https://gradleinc.wistia.com/medias/ymycpvtfm8',
};
